<template>
	<div class="bounceManage">

		<div class="breadcrumb">APP首页弹框管理
			<el-button class="right_f" type="primary" @click="newBounce">新增</el-button>
		</div>

		<div class="bounce">
			<el-select v-model="bounceStatus" @change="neirong">
				<el-option label="全部状态" value='-1'></el-option>
				<el-option label="草稿" value='0'></el-option>
				<el-option label="已发布" value='1'></el-option>
				<el-option label="已撤销" value='2'></el-option>
			</el-select>

		</div>

		<div class="com-list">
			<el-table :data="bounces" style="overflow-x: auto;">
				<el-table-column prop="index" label="序号" width="80">
				</el-table-column>
				<el-table-column prop="id" label="弹框ID" width="100">
				</el-table-column>
				<el-table-column inline-template label="弹框图片" width="150">
					<img :src="row.imgUrl">
				</el-table-column>
				<el-table-column prop="name" label="弹框名称" min-width="200">
				</el-table-column>
				<el-table-column prop="allUnidFlag" label="目标校区" width="150">
				</el-table-column>
				<el-table-column prop="showStatus" label="弹出周期" width="160">
				</el-table-column>
				<el-table-column prop="qizhiDate" label="起止日期" width="180">
				</el-table-column>
				<el-table-column prop="status" label="状态" width="100">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="170">
				</el-table-column>
				<el-table-column inline-template label="操作" width="120">
					<div class="btn-box">
						<el-button class="option" type="text" @click="showDetail(row.id)">详情</el-button>
						<el-button class="option" type="text" v-if="row.status !== '已发布'" @click="editNew(row.id)">修改</el-button>
						<el-button class="option" type="text" v-if="row.status == '已发布'" @click="updateStatus(row,1)">撤销发布</el-button>
						<el-button class="option" type="text" v-if="row.status !== '已发布'" @click="updateStatus(row,0)">发布</el-button>
						<el-button class="option" type="text" v-if="row.status !== '已发布'" @click="deleteBounce(row)">删除</el-button>
					</div>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				bounceStatus: '-1',
				bounces: []
			}
		},
		mounted() {
			//请求获取bounces数据
			this.paramAndGet();
		},
		methods: {
			paramAndGet() {
				let url = window.location.href;

				if (url.indexOf('?') !== -1) {
					this.bounceStatus = this.$util.getUrlParam('status');
					this.getBounces(this.bounceStatus);
				} else {
					this.getBounces();
				}
			},
			neirong() {
				location.href = '/#/yunying/bounce/bounceManage?status=' + this.bounceStatus;
				this.paramAndGet();
			},
			getBounces(status) {
				this.status = status || -1;
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v1/operate/bounce/list?status=' + this.status
				}).then((response) => {
					if (response.data.error === 10000) {
						let dataList = response.data.data;
						//处理获取到的bounce数据
						this.bounces = [];
						for (let i = 0; i < dataList.length; i++) {
							let name = dataList[i].name,
								index = i + 1,
								imgUrl = dataList[i].imgUrl,
								targetUrl = dataList[i].targetUrl,
								showStatus = dataList[i].showStatus,
								status = dataList[i].status,
								id = dataList[i].id,
								allUnidFlag = dataList[i].allUnidFlag,
								createTime = new Date(dataList[i].createTime),
								startTime = new Date(dataList[i].startTime),
								endTime = new Date(dataList[i].endTime);
							if (allUnidFlag == "1") {
								allUnidFlag = "部分校区";
							} else {
								allUnidFlag = "全部校区";
							};
							switch (showStatus) {
								case 1:
									showStatus = '每天首次启动APP';
									break;
								case 2:
									showStatus = '每次启动APP';
									break;
								case 3:
									showStatus = '活动期间仅弹出一次';
									break;
							};
							switch (status) {
								case 0:
									status = '草稿';
									break;
								case 1:
									status = '已发布';
									break;
								case 2:
									status = '已撤销';
									break;
							};
							this.bounces.push({
								name,
								index,
								imgUrl,
								allUnidFlag,
								targetUrl,
								showStatus,
								status,
								id,
								createTime: createTime.format("yyyy/MM/dd hh:mm"),
								qizhiDate: startTime.format("yyyy/MM/dd hh:mm:ss") + "  -  " + endTime.format("yyyy/MM/dd hh:mm:ss")
							})

						}
					}
				})
			},
			showDetail(id) {
				location.href = "#/yunying/bounce/bounceDetail?bounceId=" + id;
			},
			newBounce() {
				location.href = "#/yunying/bounce/newBounce";
			},
			editNew(id) {
				location.href = "#/yunying/bounce/newBounce?bounceId=" + id;
			},
			deleteBounce(row) {
				this.$confirm('你确定要删除弹框“' + row.name + "”吗？", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						method: 'POST',
						url: this.$util.domain + '/adminapi/v1/operate/bounce/delete?bounceId=' + row.id
					}).then((response) => {
						if (response.data.error === 10000) {
							this.paramAndGet();
						}
					})
				})
			},
			updateStatus(row, status) {
				if (status == "1") {
					this.$confirm('你确定要撤销弹框“ ' + row.name + " ”吗？", '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.change_status(row, 2);
					})
				} else {
					this.$confirm('你确定要将弹框“' + row.name + "”发布吗？", '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.change_status(row, 1);
					})

				}

			},
			change_status(row, status) {
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v1/operate/bounce/updateStatus?bounceId=' + row.id + "&status=" + status
				}).then((response) => {
					if (response.data.error === 10000) {
						this.paramAndGet();
					}
				})
			}
		}
	}
</script>
<style>
	.bounceManage .el-select {
		display: inline-block;
	}

	.bounceManage img {
		display: block;
		width: 70%;
		height: 80%;
		margin: 10px;
	}

	.bounceManage .btn-box .el-button {
		width: 70px;
		padding: 5px;
		margin-bottom: 5px;
		border: solid 1px #999;
	}

	.bounceManage .el-input {
		display: inline-block;
	}

	.bounceManage .el-button {
		display: inline-block;
	}

	.bounceManage .el-button+.el-button {
		margin-left: 0;
	}

	.bounce {
		margin-left: 30px;
		margin-bottom: 20px;
	}
</style>


// WEBPACK FOOTER //
// bounceManage.vue?004c81ea